import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UwTimelineComponent } from './uw-timeline.component';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '@uw/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { StatusIndicatorModule } from '../status-indicator';



@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        SharedModule,
        TranslateModule,
        StatusIndicatorModule,
        UwTimelineComponent
    ],
    exports: [UwTimelineComponent]
})
export class UwTimelineModule { }
